import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface HeroRotatingTextProps {
  words: string[];
  className?: string;
  interval?: number;
}

const HeroRotatingText = ({ 
  words, 
  className = "", 
  interval = 3000 
}: HeroRotatingTextProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, interval);

    return () => clearInterval(timer);
  }, [words.length, interval]);

  return (
    <span className={`relative inline-block ${className}`}>
      <AnimatePresence mode="wait">
        <motion.span
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ 
            duration: 0.4, 
            ease: "easeInOut" 
          }}
          className="inline-block text-accent"
        >
          {words[currentIndex]}
        </motion.span>
      </AnimatePresence>
      {/* Blinking cursor effect */}
      <motion.span
        className="inline-block w-[3px] h-[0.9em] bg-accent ml-1 align-middle"
        animate={{ opacity: [1, 0, 1] }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      />
    </span>
  );
};

export default HeroRotatingText;
